/* Column Menu (Desktop, 02b Prada-Muster) — eigenständige Steuerung.
   Übernimmt den Header-Burger ab 1000px (Capture-Phase, Vendor-Drawer bleibt
   für Mobile zuständig und wird nicht angefasst). */

(function () {
  'use strict';

  var menu = document.getElementById('column-menu');
  if (!menu) return;

  var desktop = window.matchMedia('(min-width: 1000px)');
  var trigger = document.querySelector('.header__main-nav button[aria-controls="header-sidebar-menu"]');
  var rootList = menu.querySelector('.column-menu__list--root');
  var groups = menu.querySelectorAll('.column-menu__group');
  var letzterFokus = null;

  var closeSub = function () {
    menu.classList.remove('is-sub-open');
    groups.forEach(function (g) { g.hidden = true; });
    if (rootList) {
      rootList.querySelectorAll('[data-active]').forEach(function (li) { li.removeAttribute('data-active'); });
      rootList.querySelectorAll('[aria-expanded="true"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    }
  };

  var open = function () {
    letzterFokus = document.activeElement;
    menu.hidden = false;
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { menu.classList.add('is-open'); });
    });
    document.documentElement.style.overflow = 'hidden';
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    var first = menu.querySelector('.column-menu__link');
    if (first) first.focus({ preventScroll: true });
  };

  var close = function () {
    menu.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
    window.setTimeout(function () {
      menu.hidden = true;
      closeSub();
    }, 250);
    if (letzterFokus && letzterFokus.focus) letzterFokus.focus({ preventScroll: true });
  };

  // Burger ab 1000px übernehmen (Capture-Phase: Vendor-Handler sieht den Klick nicht)
  document.addEventListener('click', function (event) {
    if (!desktop.matches || !trigger) return;
    if (event.target === trigger || trigger.contains(event.target)) {
      event.preventDefault();
      event.stopPropagation();
      if (menu.hidden) { open(); } else { close(); }
    }
  }, true);

  // Ebene-1-Punkte mit Unterebene: Spalte 2 öffnen/wechseln
  menu.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-column-target]');
    if (btn) {
      var ziel = document.getElementById(btn.getAttribute('data-column-target'));
      if (!ziel) return;
      groups.forEach(function (g) { g.hidden = g !== ziel; });
      menu.classList.add('is-sub-open');
      rootList.querySelectorAll('[data-active]').forEach(function (li) { li.removeAttribute('data-active'); });
      rootList.querySelectorAll('[aria-expanded="true"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      btn.closest('.column-menu__item').setAttribute('data-active', '');
      btn.setAttribute('aria-expanded', 'true');
      return;
    }

    if (event.target.closest('[data-column-menu-close]')) close();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && !menu.hidden) close();
  });

  // Fokus im Dialog halten: role="dialog" ohne Vendor-Focus-Trap — Tab zykliert
  // über die sichtbaren Elemente, statt hinter das Scrim zu wandern
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Tab' || menu.hidden) return;
    var fokussierbar = Array.prototype.filter.call(
      menu.querySelectorAll('a[href], button:not([disabled])'),
      function (el) { return el.offsetParent !== null; }
    );
    if (!fokussierbar.length) return;
    var erster = fokussierbar[0];
    var letzter = fokussierbar[fokussierbar.length - 1];
    var draussen = !menu.contains(document.activeElement);
    if (event.shiftKey && (document.activeElement === erster || draussen)) {
      event.preventDefault();
      letzter.focus();
    } else if (!event.shiftKey && (document.activeElement === letzter || draussen)) {
      event.preventDefault();
      erster.focus();
    }
  });

  // Search/Cart aus offenem Menü (Mobile-Drawer-Kopf UND Column-Menu-Kopf):
  // Klick auf aria-controls im offenen Dialog verpufft sonst — Menü erst
  // schließen, dann den Header-Trigger des Ziel-Drawers klicken; Fallback: href
  document.addEventListener('click', function (event) {
    var item = event.target.closest('.navigation-drawer__head [aria-controls], .column-menu__head [aria-controls]');
    if (!item) return;
    var targetId = item.getAttribute('aria-controls');
    if (targetId !== 'search-drawer' && targetId !== 'cart-drawer') return;
    event.preventDefault();
    event.stopPropagation();

    if (item.closest('.column-menu')) {
      close();
    } else {
      var navClose = document.querySelector('#header-sidebar-menu button[is="close-button"]');
      if (navClose) navClose.click();
    }

    var href = item.getAttribute('href');
    window.setTimeout(function () {
      var opener = document.querySelector('.header__wrapper [aria-controls="' + targetId + '"]');
      if (opener) {
        opener.click();
      } else if (href) {
        window.location.href = href;
      }
    }, 350);
  }, true);

  // Localization-Drawer aus offenem Menü: Der Fokus-Trap des Vendor-Drawers
  // blockiert Klicks außerhalb seines Bereichs — Menü erst schließen, dann öffnen
  // (gleiches Muster wie Search/Cart oben)
  document.addEventListener('click', function (event) {
    var item = event.target.closest('[aria-controls="localization-drawer"]');
    if (!item) return;
    var imVendorDrawer = item.closest('#header-sidebar-menu');
    var imColumnMenu = item.closest('.column-menu');
    if (!imVendorDrawer && !imColumnMenu) return;
    event.preventDefault();
    event.stopPropagation();

    if (imColumnMenu) {
      close();
    } else {
      var navClose = document.querySelector('#header-sidebar-menu button[is="close-button"]');
      if (navClose) navClose.click();
    }

    window.setTimeout(function () {
      var drawer = document.getElementById('localization-drawer');
      if (drawer && typeof drawer.show === 'function') drawer.show();
    }, 350);
  }, true);

  // Beim Verlassen des Desktop-Breakpoints schließen (Mobile übernimmt der Vendor-Drawer)
  desktop.addEventListener('change', function (e) {
    if (!e.matches && !menu.hidden) close();
  });
})();
